import { FieldHasValue, ValidateNumberField, ExponentialToDecimal } from 'helpers/Validation';

export const AsLeftResultFormula = (formData) => {
    if (FieldHasValue(formData.F78Deviation2Eu1)
        && FieldHasValue(formData.F79Deviation2Eu2)
        && FieldHasValue(formData.F80Deviation2Eu3) && FieldHasValue(formData.F60ToleranceEu)) {
        if (Math.max(ValidateNumberField(formData.F78Deviation2Eu1), ValidateNumberField(formData.F79Deviation2Eu2), ValidateNumberField(formData.F80Deviation2Eu3))
            <= ValidateNumberField(formData.F60ToleranceEu)) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};

export const AsLeftTableF78Deviation2Eu1Formula = (formData) => FieldHasValue(formData.F1060AltTestSpeed1) && FieldHasValue(formData.F109AltHmireading1)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1060AltTestSpeed1) - ValidateNumberField(formData.F109AltHmireading1))) : '';
export const AsLeftTableF79Deviation2Eu2Formula = (formData) => FieldHasValue(formData.F1061AltTestSpeed2) && FieldHasValue(formData.F113AltHmireading2)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1061AltTestSpeed2) - ValidateNumberField(formData.F113AltHmireading2))) : '';
export const AsLeftTableF80Deviation2Eu3Formula = (formData) => FieldHasValue(formData.F1062AltTestSpeed3) && FieldHasValue(formData.F114AltHmireading3)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1062AltTestSpeed3) - ValidateNumberField(formData.F114AltHmireading3))) : '';
